export type DonutInput = { key: string; value: number };
export type DonutSegment = {
  key: string;
  /** Fraction of the circle where the segment starts, 0..1 clockwise from 12. */
  start: number;
  /** Fraction of the circle the segment covers, gap already subtracted. */
  length: number;
};

/**
 * Pure geometry for a donut ring: value shares as circle fractions, with a
 * fixed gap taken out of every segment so shares stay proportional. The
 * component multiplies by the circumference for stroke-dasharray.
 */
export function computeDonutSegments(inputs: DonutInput[], gap: number): DonutSegment[] {
  const positive = inputs.filter((input) => input.value > 0);
  const total = positive.reduce((sum, input) => sum + input.value, 0);
  if (total <= 0) return [];
  // A lone segment is a full ring: a gap against itself reads as a glitch.
  const effectiveGap = positive.length > 1 ? gap : 0;

  let cursor = 0;
  return positive.map((input) => {
    const share = input.value / total;
    const segment = { key: input.key, start: cursor, length: share - effectiveGap };
    cursor += share;
    return segment;
  });
}
